// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"f677c0c5","229":"2a8a26e9","365":"630d6850","453":"a5072149","859":"feef15f6","928":"7c712c10"}[chunkId] + ".chunk.js";
};